import axios from "axios";
import { API_BASE_URL, getAuthToken } from "../artistStudio/shared";

// GET /v1/licence-notice/needed: the signed-in creator's own videos that need a licence now, grouped by sound.
// Notices only: nothing is muted or removed. Result: { account_class, class_label, total_videos, sounds: [{ track_id, title, videos: [{ post_id, title }] }] }.
export const licenceNoticeApi = {
  needed: () => axios
    .get(`${API_BASE_URL}/v1/licence-notice/needed`, { headers: { token: getAuthToken(), "Content-Type": "application/json" }, timeout: 20000 })
    .then((response) => response.data?.result)
};
